(function () {
  const CustomerConsentBase = window.CustomerConsent;
  if (typeof CustomerConsentBase !== "function") {
    console.error(
      "CustomerConsentV2: window.CustomerConsent is missing. Ensure customer_consent.js loads first."
    );
    return;
  }

  class CustomerConsentV2 extends CustomerConsentBase {
    configure() {
      super.configure();
      this.ui.form = "#FormConsentV2";
      this.ui.customerCellphoneConfirmation = "#customer_consent_cellphone_number_confirmation";
      this.ui.customerEmailConfirmation = "#customer_consent_email_confirmation";
      this.ui.hasSecondNationality = "#customer_consent_customer_attributes_has_second_nationality";
      this.ui.secondNationalityCountry = "#customer_consent_customer_attributes_second_nationality_country";
      this.ui.nitNationalField = "#nit_national_field";
      this.ui.photoFrontFile = "#v2_photo_front_file";
      this.ui.photoBackFile = "#v2_photo_back_file";
      this.ui.photoFrontTemp = "#customer_consent_id_photo_front_temp";
      this.ui.photoBackTemp = "#customer_consent_id_photo_back_temp";
      this.ui.jsFrontPhonto = ".js-front-photo";
      this.ui.jsBackPhoto = ".js-back-photo";
      this.ui.jsCustomerPhoto = "label[for='customer_consent_id_photo_with_user'], .js-customer-photo";
      this.ui.veriffSwitch = "#customSwitch0";
      this.ui.veriffSessionId = "#customer_consent_veriff_session_id";
      this.ui.submitBtn = "#submitBtn";
      this.ui.apcSmsBtn = "#apcSmsBtn";
      this.ui.apcDeclaration = "#apcSellerDeclaration";
      this.ui.apcViewLetterBtn = "#apcViewLetterBtn";
      this.ui.identitySection = "#v2IdentitySection";
      this.ui.apcSignedBanner = "#apcSignedBanner";
      this.veriffFinished = false;
      this.apcSmsVerified = false;
      this._submitIntent = "sms";
      this._veriffIdNumber = null;
    }

    loadComponents() {
      const operation = this;

      operation.configure();
      operation.loadDataCompanyID();
      operation.loadSelect2();
      operation.onlyLetterV2();
      operation.onlyNumber();
      // Avoid keyup→.val() uppercasing (drops characters while typing). CSS handles it.
      operation.needFormValidation();
      operation.maskedNumber();
      operation.validateDNI();
      operation.changeLabelOnNationality();
      operation.toggleNationalityCountry();
      operation.toggleBirthCountry();
      operation.toggleNitFieldsForPanama();
      operation.loadValidateBirthDate();
      operation.loadCustomerAgeDisplay();
      if (!$("#FormConsentV2").data("public-preapproval")) {
        operation.loadSearchCustomer();
      }
      operation.loadDocumentScreeningV2();
      operation.loadSendConsent();
      operation.bindFilePickers();
      operation.bindBase64PhotoUploads();
      operation.bindConfirmationRules();
      operation.bindApcAuthorizationStep();
      operation.bindVeriffStartButton();

      // Front/back manuales solo cuando NO hay Veriff (V1: las captura el SDK).
      if (!gon.veriff_available && gon.global["integration_type"]["equality"]) {
        operation.addValidatorIdentityPhotosV2();
      }

      // V1-identical Veriff switch flow (T&C modal → frame → poll / uncheck on cancel).
      operation.addValidatorIdentityV2();
      operation.bindCedulaChangeResetsVeriff();
    }

    // Safer than Common#onlyLetter (String.fromCharCode + keydown fights IME/fast typing)
    onlyLetterV2() {
      const $form = $(this.ui.form);
      $form
        .off("keypress.loanFlowOnlyLetter", this.ui.jsOnlyLetter)
        .on("keypress.loanFlowOnlyLetter", this.ui.jsOnlyLetter, function (evt) {
          if (evt.ctrlKey || evt.metaKey || evt.altKey) return;
          const key = evt.key;
          if (!key || key.length !== 1) return;
          if (!/^[A-Za-zÀ-ÿ\u00f1\u00d1\s]$/.test(key)) {
            evt.preventDefault();
          }
        });

      // Uppercase on blur only — never rewrite value on every keystroke
      $form
        .off("blur.loanFlowUpper", ".text-uppercase")
        .on("blur.loanFlowUpper", ".text-uppercase", function () {
          this.value = this.value.toUpperCase();
        });
    }

    bindConfirmationRules() {
      const operation = this;

      $(operation.ui.customerIdNumberConfirmation).rules("add", {
        equalTo: operation.ui.customerIdNumber,
      });

      $(operation.ui.customerCellphoneConfirmation).rules("add", {
        equalTo: operation.ui.customerCellphone,
        phone8Digits: true
      });

      $(operation.ui.customerEmail).rules("add", {
        validateEmail: { loan_id: "true" },
      });

      $(operation.ui.customerEmailConfirmation).rules("add", {
        equalTo: operation.ui.customerEmail,
      });
    }

    bindFilePickers() {
      const operation = this;

      $(document)
        .off("click.loanFlowFile", ".js-loan-flow-file-trigger")
        .on("click.loanFlowFile", ".js-loan-flow-file-trigger", function (e) {
          e.preventDefault();
          $(this).closest("[data-loan-flow-file]").find(".js-loan-flow-file-input").trigger("click");
        });

      $(document)
        .off("change.loanFlowFile", ".js-loan-flow-file-input")
        .on("change.loanFlowFile", ".js-loan-flow-file-input", function () {
          const input = this;
          const file = input.files && input.files[0];
          const $wrap = $(input).closest("[data-loan-flow-file]");
          const $name = $wrap.find(".js-loan-flow-file-name");

          if (file && !operation.loanFlowFileMatchesAccept(file, input.accept)) {
            operation.showLoanFlowFileTypeError($wrap, file);
            input.value = "";
            return;
          }

          operation.clearLoanFlowFileTypeError($wrap);

          if (file) {
            $name.text(file.name).addClass("loan-flow-v2__file-name--selected");
          } else {
            $name.text("Seleccione el archivo").removeClass("loan-flow-v2__file-name--selected");
          }
        });
    }

    loanFlowFileExtension(file) {
      const name = (file && file.name) || "";
      const ext = name.includes(".") ? name.split(".").pop() : "";
      return ext ? `.${ext.toLowerCase()}` : (file && file.type) || "";
    }

    loanFlowFileMatchesAccept(file, accept) {
      if (!file || !accept) return true;

      const tokens = String(accept)
        .split(",")
        .map((token) => token.trim().toLowerCase())
        .filter(Boolean);
      if (!tokens.length) return true;

      const name = (file.name || "").toLowerCase();
      const ext = name.includes(".") ? name.split(".").pop() : "";
      const mime = (file.type || "").toLowerCase();
      const imageExts = ["jpg", "jpeg", "png", "gif"];

      return tokens.some((token) => {
        if (token === "image/*") {
          return imageExts.includes(ext) || ["image/jpeg", "image/jpg", "image/png", "image/gif"].includes(mime);
        }
        if (token === "application/pdf") {
          return ext === "pdf" || mime === "application/pdf";
        }
        if (token.startsWith(".")) {
          return ext === token.slice(1);
        }
        if (token.includes("/")) {
          return mime === token;
        }
        return ext === token;
      });
    }

    showLoanFlowFileTypeError($wrap, file) {
      const extension = this.loanFlowFileExtension(file) || "este tipo";
      const types = $wrap.attr("data-allowed-types") || "";
      const template =
        $wrap.attr("data-invalid-file-message") ||
        "No se permite subir archivos %{extension}. Formatos permitidos: %{types}";
      const message = String(template)
        .replace(/%\{extension\}/g, extension)
        .replace(/%\{types\}/g, types);

      $wrap.addClass("is-invalid");
      $wrap.find(".js-loan-flow-file-error").text(message).prop("hidden", false);
      $wrap
        .find(".js-loan-flow-file-name")
        .text("Seleccione el archivo")
        .removeClass("loan-flow-v2__file-name--selected");
    }

    clearLoanFlowFileTypeError($wrap) {
      $wrap.removeClass("is-invalid");
      $wrap.find(".js-loan-flow-file-error").text("").prop("hidden", true);
    }

    bindBase64PhotoUploads() {
      const operation = this;

      $(operation.ui.photoFrontFile).on("change", function (element) {
        operation.readFileAsBase64(element.target.files[0], operation.ui.photoFrontTemp);
      });

      $(operation.ui.photoBackFile).on("change", function (element) {
        operation.readFileAsBase64(element.target.files[0], operation.ui.photoBackTemp);
      });
    }

    readFileAsBase64(file, target) {
      if (!file) {
        $(target).val("");
        return;
      }

      const reader = new FileReader();
      reader.onloadend = function () {
        $(target).val(reader.result);
      };
      reader.readAsDataURL(file);
    }

    addValidatorIdentityPhotosV2() {
      const operation = this;
      const $form = $(operation.ui.form);
      if (!$form.length || !$form.data("validator")) return;

      $.validator.addMethod(
        "v2PhotoFrontRequired",
        function () {
          return !!$(operation.ui.photoFrontTemp).val() || (!!$(operation.ui.photoFrontFile)[0] && $(operation.ui.photoFrontFile)[0].files.length > 0);
        },
        "Este campo es obligatorio."
      );

      $.validator.addMethod(
        "v2PhotoBackRequired",
        function () {
          return !!$(operation.ui.photoBackTemp).val() || (!!$(operation.ui.photoBackFile)[0] && $(operation.ui.photoBackFile)[0].files.length > 0);
        },
        "Este campo es obligatorio."
      );

      $(operation.ui.photoFrontFile).rules("add", { v2PhotoFrontRequired: true });
      $(operation.ui.photoBackFile).rules("add", { v2PhotoBackRequired: true });
    }

    bindCedulaChangeResetsVeriff() {
      const operation = this;
      const $id = $(operation.ui.customerIdNumber);
      if (!$id.length) return;

      $id
        .off("input.veriffIdentity change.veriffIdentity")
        .on("input.veriffIdentity change.veriffIdentity", function () {
          const current = String($(this).val() || "")
            .replace(/[^A-Za-z0-9]/g, "")
            .toUpperCase();
          const searched = String(operation._lastSearchedDni || "")
            .replace(/[^A-Za-z0-9]/g, "")
            .toUpperCase();
          if (searched && current && current !== searched) {
            $(operation.ui.customerId).val("");
          }
          const used = operation._veriffIdNumber;
          if (!used) return;
          if (current !== used) operation.resetBiometricVerification();
        });
    }

    veriffSwitchOn() {
      const $switch = $("#customSwitch0");
      return (
        this.veriffFinished ||
        ($switch.length > 0 && ($switch.prop("checked") || $switch.is(":checked")))
      );
    }

    // Port of Loan#addValidatorIdentity (V1) for step-1 V2 form.
    addValidatorIdentityV2() {
      const operation = this;
      const veriffTimeoutMs = (gon.global["veriff_timeout"] || 10) * 60 * 1000;
      operation.ui.customerSwtich0 = "#customSwitch0";

      $(operation.ui.customerSwtich0)
        .off("click.veriffV2 change.veriffV2Unlock")
        .on("change.veriffV2Unlock", function () {
          if ($(this).prop("checked")) {
            operation._unblockSubmitButtonV2();
          }
        })
        .on("click.veriffV2", function (evt) {
          if (!$(this).is(":checked")) {
            // Unchecking: clear session and allow.
            $(operation.ui.veriffSessionId).val("");
            operation.veriffFinished = false;
            return;
          }

          var isVeriffAvailable = gon.veriff_available;

          // Sin Veriff: exigir fotos manuales. Con Veriff: solo foto del cliente con cédula.
          if (!operation.photosReadyForVeriff() || (!isVeriffAvailable && !$(operation.ui.form).valid())) {
            evt.preventDefault();
            evt.stopImmediatePropagation();
            evt.stopPropagation();
            if (isVeriffAvailable && !operation.photosReadyForVeriff()) {
              operation._blockSubmitButtonV2(
                "Suba la foto del cliente con la cédula antes de iniciar Veriff."
              );
            }
            return;
          }

          // With Veriff: intercept toggle → show T&C first (same as V1).
          if (isVeriffAvailable) {
            evt.preventDefault();

            const $modal = $("#veriffTermsModal");
            if ($modal.parent()[0] !== document.body) {
              $modal.appendTo("body");
            }

            $modal.off("hidden.bs.modal.veriffTerms");
            $("#veriffTermsAccept").off("click.veriffTerms");
            $("#veriffTermsReject").off("click.veriffTerms");

            $modal.modal("show");

            $("#veriffTermsAccept").one("click.veriffTerms", function (e) {
              e.stopPropagation();
              $modal.modal("hide");
              $("#customSwitch0").prop("checked", true);
              operation._unblockSubmitButtonV2();
              operation._launchVeriffV2(isVeriffAvailable, veriffTimeoutMs);
            });

            $("#veriffTermsReject").one("click.veriffTerms", function (e) {
              e.stopPropagation();
              $modal.modal("hide");
              $("#customSwitch0").prop("checked", false);
            });

            $modal.one("hidden.bs.modal.veriffTerms", function () {
              if (!$("#customSwitch0").prop("checked")) {
                $("#customSwitch0").prop("checked", false);
              }
            });

            return;
          }

          // Sin Veriff (development sin credenciales/webhook): no llamar API.
          operation.markIdentityVerified();
          return;
        });
    }

    bindVeriffStartButton() {
      const operation = this;
      $("#v2StartVeriffBtn")
        .off("click.startVeriff")
        .on("click.startVeriff", function (e) {
          e.preventDefault();
          if (!operation.photosReadyForVeriff()) {
            operation._blockSubmitButtonV2(
              "Suba la foto del cliente con la cédula antes de iniciar Veriff."
            );
            return;
          }
          const $sw = $("#customSwitch0");
          $sw.prop("checked", true);
          $sw.triggerHandler("click.veriffV2");
        });
    }

    markIdentityVerified() {
      this.veriffFinished = true;
      const idNumber = String($(this.ui.customerIdNumber).val() || "")
        .replace(/[^A-Za-z0-9]/g, "")
        .toUpperCase();
      if (idNumber) this._veriffIdNumber = idNumber;
      $("#customSwitch0").prop("checked", true);
      const $btn = $("#v2StartVeriffBtn");
      if ($btn.length) {
        if (!$btn.data("original-label")) $btn.data("original-label", $btn.text());
        $btn.prop("disabled", true).text("Identidad verificada");
      }
      this.revealApcAfterIdentity();
      this._unblockSubmitButtonV2();
      if (typeof window.rememberPublicVeriff === "function") window.rememberPublicVeriff();
    }

    resetBiometricVerification() {
      const $btn = $("#v2StartVeriffBtn");
      const original = $btn.data("original-label");
      super.resetBiometricVerification();
      if ($btn.length && original) {
        $btn.prop("disabled", false).text(original);
      }
      if (typeof window.forgetPublicVeriff === "function") window.forgetPublicVeriff();
    }

    revealApcAfterIdentity() {
      const $apc = $("#v2ApcSection");
      if (!$apc.length) return;
      $apc.removeClass("d-none").attr("aria-hidden", "false");
      this.syncApcSmsButton();
      const top = $apc.offset();
      if (top) {
        $("html, body").animate({ scrollTop: top.top - 24 }, 300);
      }
    }

    identityReadyForApc() {
      if (this.veriffRequired()) return this.identityVerifiedInternally();
      return this.photosReadyForVeriff() || this.veriffSwitchOn();
    }

    // Visible Veriff switch was removed. Keep completion internal:
    // production + Veriff on → session/SDK must have finished.
    // development → skip so local/maquetas-without-Veriff can continue.
    veriffRequired() {
      if (gon.rails_env === "development") return false;
      return !!gon.veriff_available;
    }

    identityVerifiedInternally() {
      if (!this.veriffRequired()) return true;
      return (
        this.veriffFinished ||
        !!String($(this.ui.veriffSessionId).val() || "").trim()
      );
    }

    syncApcSmsButton() {
      if (this.apcSmsVerified) {
        $(this.ui.apcSmsBtn).prop("disabled", true);
        return;
      }
      const declared = $(this.ui.apcDeclaration).is(":checked");
      $(this.ui.apcSmsBtn).prop("disabled", !declared || !this.identityReadyForApc());
    }

    photosReadyForVeriff() {
      const operation = this;
      if ($("#FormConsentV2").data("public-preapproval")) return true;

      const $withUser = $("#customer_consent_id_photo_with_user");
      const hasWithUser =
        !!$withUser.val() ||
        (!!$withUser[0] && $withUser[0].files && $withUser[0].files.length > 0);

      // Con Veriff solo se pide la foto del cliente con la cédula (front/back vienen de Veriff).
      if (gon.veriff_available) return hasWithUser;

      const hasFront =
        !!$(operation.ui.photoFrontTemp).val() ||
        (!!$(operation.ui.photoFrontFile)[0] && $(operation.ui.photoFrontFile)[0].files.length > 0);
      const hasBack =
        !!$(operation.ui.photoBackTemp).val() ||
        (!!$(operation.ui.photoBackFile)[0] && $(operation.ui.photoBackFile)[0].files.length > 0);
      return hasFront && hasBack && hasWithUser;
    }

    // Port of Loan#_launchVeriff for V2 (stores session on consent hidden field + Continuar btn).
    _launchVeriffV2(isVeriffAvailable, veriffTimeoutMs) {
      const operation = this;
      const $form = $(operation.ui.form);

      // Prefer explicit V2 ids, then name= (bootstrap_form nested attributes).
      function fieldVal() {
        for (var i = 0; i < arguments.length; i++) {
          var sel = arguments[i];
          var $el = $form.find(sel).add(sel);
          if ($el.length && $el.first().val()) return String($el.first().val()).trim();
        }
        return "";
      }

      var firstName = fieldVal(
        operation.ui.customerFirstName,
        "#loan_customer_attributes_first_name",
        "#customer_consent_customer_attributes_first_name",
        "input[name='customer_consent[customer_attributes][first_name]']"
      );
      var firstLast = fieldVal(
        operation.ui.customerFirstLastName,
        "#loan_customer_attributes_first_last_name",
        "#customer_consent_customer_attributes_first_last_name",
        "input[name='customer_consent[customer_attributes][first_last_name]']"
      );
      var secondLast = fieldVal(
        operation.ui.customerSecondLastName,
        "#customer_consent_customer_attributes_second_last_name",
        "input[name='customer_consent[customer_attributes][second_last_name]']"
      );
      var rawId = fieldVal(
        operation.ui.customerIdNumber,
        "#customer_consent_customer_attributes_id_number",
        "input[name='customer_consent[customer_attributes][id_number]']",
        "input.js-validate-dni",
        "input.ValidateDNI"
      );
      // Veriff only accepts A-Z / 0-9 (Panama cédula uses hyphens).
      var idNumber = rawId.replace(/[^A-Za-z0-9]/g, "").toUpperCase();
      operation._veriffIdNumber = idNumber;
      var lastName = (firstLast + " " + secondLast).trim();

      if (!firstName || !lastName || !idNumber) {
        $("#customSwitch0").prop("checked", false);
        operation._blockSubmitButtonV2(
          "Complete nombre, apellidos y número de cédula antes de iniciar Veriff."
        );
        return;
      }

      var requestData = {
        customer_consent_id: $("#customer_consent_id").val(),
        first_name: firstName,
        last_name: lastName,
        id_number: idNumber,
      };

      // Link público: aún no hay cliente guardado. Nacional/naturalizado → ID_CARD
      // (frente y reverso). Extranjero → PASSPORT.
      if ($("#FormConsentV2").data("public-preapproval")) {
        requestData.nationality = $(operation.ui.loanCustomerNationality).val();
      }

      if (!isVeriffAvailable) {
        // Manual photo pipeline (equality / no-veriff) — same idea as V1 selfie payload.
        const front = $(operation.ui.photoFrontTemp).val() || "";
        const back = $(operation.ui.photoBackTemp).val() || "";
        if (front.indexOf(",") !== -1) requestData.photo_front = front.split(",")[1];
        if (back.indexOf(",") !== -1) requestData.photo_back = back.split(",")[1];
      }

      operation._blockSubmitButtonV2("Iniciando Verificación...");

      bootbox.dialog({
        centerVertical: true,
        closeButton: false,
        message: i18n.t("bootbox.processing_html"),
      });

      var ajaxTimeout = setTimeout(function () {
        if (operation.veriffFinished) return;
        operation.hideBootBox();
        operation._blockSubmitButtonV2(
          i18n.t("veriff.timeout_error", {
            defaultValue: "El tiempo de espera de verificación se ha agotado.",
          })
        );
      }, veriffTimeoutMs);

      $.ajax({
        method: "POST",
        url: "/providers/veriff/sessions",
        data: requestData,
        dataType: "json",
      })
        .done(function (data) {
          if (data.success) {
            if ($(operation.ui.veriffSessionId).length === 0) {
              $("<input>")
                .attr({
                  type: "hidden",
                  id: "customer_consent_veriff_session_id",
                  name: "customer_consent[veriff_session_id]",
                  value: data.session_id,
                })
                .appendTo(operation.ui.form);
            } else {
              $(operation.ui.veriffSessionId).val(data.session_id);
            }

            if (isVeriffAvailable && data.session_url) {
              operation.hideBootBox();
              const { createVeriffFrame } = require("@veriff/incontext-sdk");
              createVeriffFrame({
                url: data.session_url,
                onEvent: function (msg) {
                  if (msg === "FINISHED") {
                    bootbox.dialog({
                      centerVertical: true,
                      closeButton: false,
                      message:
                        i18n.t("bootbox.processing_html") ||
                        "Procesando verificación...",
                    });
                    startPolling(data.session_id);
                  } else if (msg === "CANCELED" || msg === "ABANDONED") {
                    clearTimeout(ajaxTimeout);
                    $("#customSwitch0").prop("checked", false);
                    $(operation.ui.veriffSessionId).val("");
                    operation.veriffFinished = false;
                    $("#v2StartVeriffBtn").prop("disabled", false);
                    operation._unblockSubmitButtonV2();
                  } else if (msg === "ERROR") {
                    clearTimeout(ajaxTimeout);
                    $("#customSwitch0").prop("checked", false);
                    $(operation.ui.veriffSessionId).val("");
                    operation.veriffFinished = false;
                    $("#v2StartVeriffBtn").prop("disabled", false);
                    operation._blockSubmitButtonV2(
                      "Ocurrió un error en la verificación. Por favor, intente nuevamente."
                    );
                  }
                },
              });
            } else if (data.skipped || data.status === "approved") {
              clearTimeout(ajaxTimeout);
              operation.hideBootBox();
              operation.markIdentityVerified();
            } else {
              startPolling(data.session_id);
            }

            function startPolling(sessionId) {
              var pollInterval = setInterval(function () {
                $.ajax({
                  method: "GET",
                  url: "/providers/veriff/sessions/" + sessionId + "/status",
                  dataType: "json",
                })
                  .done(function (statusData) {
                    if (statusData.status === "approved") {
                      clearInterval(pollInterval);
                      clearTimeout(ajaxTimeout);
                      operation.hideBootBox();
                      operation.markIdentityVerified();
                    } else if (
                      statusData.status === "resubmission_requested" ||
                      statusData.status === "resubmission"
                    ) {
                      clearInterval(pollInterval);
                      clearTimeout(ajaxTimeout);
                      operation.hideBootBox();
                      var resubmissionMsg =
                        statusData.reason ||
                        "Se requiere que envíe nuevamente las fotos.";
                      operation._blockSubmitButtonV2(resubmissionMsg);
                    } else if (
                      statusData.status === "declined" ||
                      statusData.status === "abandoned"
                    ) {
                      clearInterval(pollInterval);
                      clearTimeout(ajaxTimeout);
                      operation.hideBootBox();
                      var declinedMsg =
                        statusData.reason ||
                        "La verificación falló. Por favor, intente nuevamente.";
                      $("#customSwitch0").prop("checked", false);
                      $(operation.ui.veriffSessionId).val("");
                      operation.veriffFinished = false;
                      operation._blockSubmitButtonV2(declinedMsg);
                    }
                  })
                  .fail(function () {
                    clearInterval(pollInterval);
                    clearTimeout(ajaxTimeout);
                    operation.hideBootBox();
                    operation._blockSubmitButtonV2(
                      "La verificación falló. Por favor, intente nuevamente."
                    );
                  });
              }, 2000);
            }
          } else {
            clearTimeout(ajaxTimeout);
            operation.hideBootBox();
            $("#customSwitch0").prop("checked", false);
            operation._blockSubmitButtonV2(
              (data && data.error) ||
                "La verificación falló. Por favor, intente nuevamente."
            );
          }
        })
        .fail(function (jqXHR, textStatus) {
          clearTimeout(ajaxTimeout);
          operation.hideBootBox();
          $("#customSwitch0").prop("checked", false);
          var msg =
            textStatus === "timeout"
              ? "El tiempo de espera de verificación se ha agotado."
              : (jqXHR.responseJSON && jqXHR.responseJSON.error) ||
                "La verificación falló. Por favor, intente nuevamente.";
          operation._blockSubmitButtonV2(msg);
        });
    }

    _blockSubmitButtonV2(message, options) {
      const lock = !options || options.lock !== false;
      const btn = $(this.ui.submitBtn);
      if (lock) {
        btn.prop("disabled", true).addClass("btn-danger");
      }
      let alert = $("#veriff-error-alert");
      if (alert.length === 0) {
        alert = $(
          '<div id="veriff-error-alert" class="alert alert-danger mt-3" role="alert"></div>'
        );
        btn.before(alert);
      }
      alert.text(message).show();
    }

    _restoreSubmitButtonV2() {
      const btn = $(this.ui.submitBtn);
      const enableWith = btn.data("ujs:enable-with");
      if (enableWith) btn.html(enableWith);
      btn.prop("disabled", false);
    }

    _unblockSubmitButtonV2() {
      this._restoreSubmitButtonV2();
      $(this.ui.submitBtn).removeClass("btn-danger");
      $("#veriff-error-alert").hide();
    }

    // Override parent: Panama V2 nationality / birth-country rules
    // - Cédula (national): both locked to Panamá (disabled)
    // - Cédula E / Cédula PN: full country lists
    toggleNationalityCountry() {
      const operation = this;
      const $form = $(operation.ui.form);
      if (!$form.length) return;

      const panamaCountry = $form.data("panama-country") || "Panamá";
      let allCountries = [];
      try {
        allCountries = JSON.parse($form.attr("data-all-countries") || "[]");
      } catch (e) {
        allCountries = [];
      }

      function fillSelect($select, options, selectedValue) {
        if (!$select.length) return;
        const current = selectedValue || $select.val();
        $select.empty();
        $select.append($("<option>").val("").text("Seleccione"));
        (options || []).forEach(function (pair) {
          const label = pair[0];
          const value = pair[1];
          $select.append($("<option>").val(value).text(label));
        });
        if (current) $select.val(current);
        if ($select.hasClass("select2-hidden-accessible")) {
          $select.trigger("change.select2");
        }
      }

      function lockToPanama($select) {
        fillSelect($select, [[panamaCountry, panamaCountry]], panamaCountry);
        $select.val(panamaCountry).prop("disabled", true).prop("required", true);
        // Disabled selects are not submitted — keep a hidden mirror so values post.
        const name = $select.attr("name");
        if (name) {
          let $mirror = $select.siblings("input.js-locked-country-mirror[data-for='" + name + "']");
          if (!$mirror.length) {
            $mirror = $("<input>", {
              type: "hidden",
              class: "js-locked-country-mirror",
              name: name,
              "data-for": name,
            });
            $select.after($mirror);
          }
          $mirror.val(panamaCountry).prop("disabled", false);
        }
        if ($select.hasClass("select2-hidden-accessible")) {
          $select.trigger("change.select2");
        }
      }

      function unlockFullList($select) {
        $select.siblings("input.js-locked-country-mirror").remove();
        const previous = $select.prop("disabled") ? "" : $select.val();
        $select.prop("disabled", false).prop("required", true);
        fillSelect($select, allCountries, previous === panamaCountry ? "" : previous);
      }

      function sync() {
        const selected = $(operation.ui.loanCustomerNationality).val();
        const $natCountry = $(operation.ui.loanCustomerNationalityCountry);
        const $birthCountry = $(operation.ui.loanCustomerBirthCountry);

        $("#nationality_country_field").removeClass("d-none");
        $("#birth_country_field").removeClass("d-none");

        if (selected === "national") {
          lockToPanama($natCountry);
          lockToPanama($birthCountry);
        } else if (selected === "foreigner" || selected === "naturalized") {
          unlockFullList($natCountry);
          unlockFullList($birthCountry);
        }

        const canTypeDocument = !!selected;
        $(operation.ui.customerIdNumber).prop("disabled", !canTypeDocument);
        $(operation.ui.customerIdNumberConfirmation).prop("disabled", !canTypeDocument);
      }

      $(operation.ui.loanCustomerNationality).off("change.loanV2Nat").on("change.loanV2Nat", sync);
      sync();
    }

    // Parent hides birth country for nationals; v2 always shows it (managed above).
    toggleBirthCountry() {
      $("#birth_country_field").removeClass("d-none");
    }

    toggleNitFieldsForPanama() {
      const operation = this;
      if (!$("#migration_card_fields").length && !$(operation.ui.nitNationalField).length) return;

      function toggle() {
        const $nationalNit = $("#customer_consent_customer_attributes_nit, #loan_customer_attributes_nit");

        $("#migration_card_fields").addClass("d-none");
        $(operation.ui.nitNationalField).removeClass("d-none");
        $nationalNit.prop("disabled", false).prop("required", false).removeClass("required");
      }

      $(operation.ui.loanCustomerNationality).on("change.v2Nit", toggle);
      toggle();
    }

    loadDocumentScreeningV2() {
      // Reuse parent screening but hit v2 validate endpoint when present
      const operation = this;
      const $form = $(operation.ui.form);
      const validateUrl = $form.data("validate-document-url");

      operation.loadDocumentScreening();

      if (validateUrl) {
        $(document).ajaxSend(function (_event, _jqXHR, settings) {
          if (settings.url && settings.url.indexOf("/v1/customer_consents/validate_document") !== -1) {
            settings.url = validateUrl;
          }
        });
      }
    }

    // After APC SMS: persist identity and continue to score/devices without a second click.
    afterSmsVerified(slug, customerConsentId) {
      this.unlockIdentityAfterApc(slug, customerConsentId);
    }

    afterIdentityComplete(slug) {
      this.runCreditScore(slug);
    }

    afterStepOneComplete(slug, _customerConsentId) {
      this.runCreditScore(slug);
    }

    unlockIdentityAfterApc(slug, customerConsentId) {
      const operation = this;
      operation.apcSmsVerified = true;
      operation._submitIntent = "identity";

      if (customerConsentId) {
        $("#customer_consent_id").val(customerConsentId);
        $("#customer_consent_record_id").val(customerConsentId);
        $(operation.ui.form).attr("data-consent-id", customerConsentId);
      }
      if (slug) {
        $("#customer_consent_slug").val(slug);
        $(operation.ui.form).attr("data-consent-slug", slug);
      }
      $(operation.ui.form).data("apc-sms-verified", true);

      $(operation.ui.apcSmsBtn).addClass("d-none").prop("disabled", true);
      $(operation.ui.apcDeclaration).prop("checked", true).prop("disabled", true);
      $(operation.ui.apcSignedBanner).removeClass("d-none");
      if (!operation.veriffRequired()) {
        operation.veriffFinished = true;
        $("#customSwitch0").prop("checked", true);
      }
      operation.lockDemographicsAfterApc();

      if (operation.identityVerifiedInternally()) {
        operation.autoContinueAfterApcSms();
        return;
      }

      $(operation.ui.submitBtn).removeClass("d-none").prop("disabled", false);
      operation._unblockSubmitButtonV2();
    }

    autoContinueAfterApcSms() {
      const $form = $(this.ui.form);
      const $btn = $(this.ui.submitBtn);
      this._submitIntent = "identity";
      $form.data("apc-sms-verified", true);
      this.prepareIdentitySubmit($form);
      $btn.addClass("d-none").prop("disabled", false);
      setTimeout(function () {
        const el = $btn.get(0);
        if (el) el.click();
      }, 250);
    }

    lockDemographicsAfterApc() {
      $("#v2IdentificationSection, #v2IdentitySection, #v2ApcSection")
        .find("input:not([type=hidden]), select, textarea, button")
        .not(this.ui.apcViewLetterBtn)
        .not("#customSwitch0")
        .prop("disabled", true);

      $("#v2IdentificationSection select").each(function () {
        const $select = $(this);
        if ($select.hasClass("select2-hidden-accessible")) {
          $select.trigger("change.select2");
        }
      });
    }

    bindApcAuthorizationStep() {
      const operation = this;
      const $form = $(operation.ui.form);
      if (!$form.length) return;

      $(operation.ui.apcDeclaration)
        .off("change.apcSms")
        .on("change.apcSms", function () {
          if (operation.apcSmsVerified) return;
          operation.syncApcSmsButton();
        });
      operation.syncApcSmsButton();

      $(operation.ui.apcSmsBtn)
        .off("click.apcIntent")
        .on("click.apcIntent", function () {
          operation._submitIntent = "sms";
        });
      $(operation.ui.submitBtn)
        .off("click.apcIntent")
        .on("click.apcIntent", function () {
          operation._submitIntent = "identity";
        });

      $(operation.ui.apcViewLetterBtn)
        .off("click.apcPreview")
        .on("click.apcPreview", function (e) {
          e.preventDefault();
          e.stopPropagation();
          operation.openApcLetterPreview();
        });

      $("#apcLetterModal")
        .off("hidden.bs.modal.apcPreview")
        .on("hidden.bs.modal.apcPreview", function () {
          const frame = document.getElementById("apcLetterFrame");
          if (frame) frame.src = "about:blank";
        });
    }

    apcLetterPreviewParams() {
      const $form = $(this.ui.form);
      const val = function (sel) {
        const $el = $form.find(sel);
        return $el.length ? String($el.first().val() || "").trim() : "";
      };
      return {
        first_name: val("#loan_customer_attributes_first_name") ||
          val("#customer_consent_customer_attributes_first_name"),
        second_name: val("#loan_customer_attributes_second_name") ||
          val("#customer_consent_customer_attributes_second_name"),
        first_last_name: val("#loan_customer_attributes_first_last_name") ||
          val("#customer_consent_customer_attributes_first_last_name"),
        second_last_name: val("#customer_consent_customer_attributes_second_last_name"),
        married_surname: val("#customer_consent_customer_attributes_married_surname"),
        id_number: val("#customer_consent_customer_attributes_id_number"),
      };
    }

    openApcLetterPreview() {
      const payload = this.apcLetterPreviewParams();
      if (!payload.first_name || !payload.first_last_name || !payload.id_number) {
        bootbox.alert(
          "Complete el nombre y la cédula del cliente para visualizar la carta."
        );
        return;
      }

      const previewUrl = $(this.ui.form).attr("data-apc-preview-url");
      if (!previewUrl) {
        bootbox.alert("No se pudo cargar la Carta de Autorización APC.");
        return;
      }

      const $modal = $("#apcLetterModal");
      if ($modal.parent()[0] !== document.body) {
        $modal.appendTo("body");
      }
      const frame = document.getElementById("apcLetterFrame");
      const url = previewUrl + (previewUrl.indexOf("?") >= 0 ? "&" : "?") + $.param(payload);
      if (frame) frame.src = url;
      $modal.modal("show");
    }

    prepareSmsSubmit($form) {
      $form.find('input[name="_method"]').remove();
      const createUrl = $form.attr("data-create-url") || "/v2/customer_consents";
      $form.attr("action", createUrl);
    }

    prepareIdentitySubmit($form) {
      const id =
        $("#customer_consent_record_id").val() ||
        $form.attr("data-consent-id") ||
        $form.data("consent-id");
      if (!id) return;

      $form.find('input[name="_method"]').remove();
      $form.append($("<input>", { type: "hidden", name: "_method", value: "patch" }));
      const completeUrl = $form.attr("data-complete-url");
      $form.attr("action", completeUrl ? completeUrl.replace("__ID__", id) : ("/v2/customer_consents/" + id + "/complete_identity"));
    }

    runCreditScore(slug) {
      if ($("#FormConsentV2").data("public-preapproval")) return;
      var item = new CreditScore();
      item.configure();
      item.check(slug);
    }

    loadSendConsent() {
      const operation = this;
      $("form#FormConsentV2")
        .off("submit.loanV2Unlock ajax:beforeSend.loanV2 ajax:complete.loanV2 ajax:success.loanV2 ajax:error.loanV2 submit.loanV2Veriff")
        .on("submit.loanV2Veriff", function (e) {
          const identitySubmit =
            operation.apcSmsVerified ||
            $(this).data("apc-sms-verified") ||
            operation._submitIntent === "identity";
          if (!identitySubmit) {
            if (!operation.identityVerifiedInternally()) {
              e.preventDefault();
              e.stopImmediatePropagation();
              bootbox.alert(
                i18n.t("loans.step_one.veriff_required", {
                  defaultValue:
                    "La verificación con Veriff es obligatoria antes de autorizar la consulta APC.",
                })
              );
              return false;
            }
            if (!$(operation.ui.apcDeclaration).is(":checked")) {
              e.preventDefault();
              e.stopImmediatePropagation();
              $(operation.ui.apcSmsBtn).prop("disabled", true);
              const publicForm = $("#FormConsentV2").data("public-preapproval");
              bootbox.alert(
                publicForm
                  ? i18n.t("loans.step_one.apc_client_declaration_required", {
                      defaultValue:
                        "Debe aceptar la Autorización de Consulta de Historial Crediticio (APC) antes de enviar el SMS.",
                    })
                  : i18n.t("loans.step_one.apc_declaration_required", {
                      defaultValue:
                        "Debe declarar que presentó y explicó la Carta de Autorización APC al cliente.",
                    })
              );
              return false;
            }
            operation.prepareSmsSubmit($(this));
            return;
          }

          if (!operation.identityVerifiedInternally()) {
            e.preventDefault();
            e.stopImmediatePropagation();
            operation._blockSubmitButtonV2(
              i18n.t("loans.step_one.veriff_required_to_continue", {
                defaultValue:
                  "Complete la verificación de identidad (Veriff) antes de continuar.",
              }),
              { lock: false }
            );
            setTimeout(function () {
              operation._restoreSubmitButtonV2();
            }, 0);
            return false;
          }
          operation.prepareIdentitySubmit($(this));
        })
        .on("ajax:beforeSend.loanV2", function () {
          // Locked country selects stay disabled; values travel via hidden mirrors.
          // Still refresh mirrors so select value is mirrored if lock changed late.
          ["loanCustomerNationalityCountry", "loanCustomerBirthCountry"].forEach(function (key) {
            const $select = $(operation.ui[key]);
            if (!$select.length || !$select.prop("disabled")) return;
            const name = $select.attr("name");
            const val = $select.val();
            if (!name || !val) return;
            let $mirror = $select.siblings("input.js-locked-country-mirror[data-for='" + name + "']");
            if (!$mirror.length) {
              $mirror = $("<input>", {
                type: "hidden",
                class: "js-locked-country-mirror",
                name: name,
                "data-for": name,
              });
              $select.after($mirror);
            }
            $mirror.val(val);
          });

          bootbox.dialog({
            centerVertical: true,
            closeButton: false,
            message: i18n.t("bootbox.processing_html"),
          });
        })
        .on("ajax:complete.loanV2", function () {
          // Keep processing dialog while create.js / Veriff take over; hide on failures only.
        })
        .on("ajax:error.loanV2", function (event, xhr, status) {
          if (!$("#FormConsentV2").data("public-preapproval")) return;

          if ((!xhr || typeof xhr.status === "undefined") && event && event.detail) {
            status = event.detail[1];
            xhr = event.detail[0];
          }

          var body = (xhr && xhr.responseText) || "";
          if (body.indexOf("stopPublicApplication") !== -1 || body.indexOf("bootbox.alert") !== -1) return;

          var httpStatus = xhr && xhr.status;
          var transportFailed =
            !xhr ||
            httpStatus === 0 ||
            httpStatus === 408 ||
            httpStatus === 502 ||
            httpStatus === 503 ||
            httpStatus === 504 ||
            status === "timeout" ||
            status === "abort";

          if (transportFailed) {
            $(".bootbox.modal").modal("hide");
            var $btn = $("#apcSmsBtn");
            var enableWith = $btn.data("ujs:enable-with");
            if (enableWith) $btn.html(enableWith);
            operation.syncApcSmsButton();
            var $note = $("#public-sms-delay");
            if (!$note.length) {
              $note = $(
                '<div id="public-sms-delay" class="alert alert-warning mt-3" role="alert"></div>'
              );
              $btn.after($note);
            }
            $note.text(
              "El envío del código tardó demasiado. Tu verificación de identidad sigue válida. Pulsa de nuevo para solicitar el SMS."
            );
            return;
          }

          if (typeof stopPublicApplication === "function") {
            stopPublicApplication(
              "Por ahora no podemos continuar con tu solicitud. Gracias por tu interés."
            );
          } else {
            $(".bootbox.modal").modal("hide");
          }
        })
        .on("ajax:success.loanV2", function () {
          // SMS create.js.erb shows the OTP modal; identity complete.js.erb runs the score.
        });
    }
  }

  window.CustomerConsentV2 = CustomerConsentV2;

  $(function () {
    const $form = $("#FormConsentV2");
    if (!$form.length || $form.data("consent-v2-booted")) return;
    $form.data("consent-v2-booted", true);
    const item = new CustomerConsentV2();
    $form.data("consentV2", item);
    item.loadComponents();
    item.forceActiveTab("loans");
  });
})();
